import { render, staticRenderFns } from "./messageDetail.vue?vue&type=template&id=a8846b1c&scoped=true&"
import script from "./messageDetail.vue?vue&type=script&lang=js&"
export * from "./messageDetail.vue?vue&type=script&lang=js&"
import style0 from "./messageDetail.vue?vue&type=style&index=0&id=a8846b1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8846b1c",
  null
  
)

export default component.exports